var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeviceAnalytics = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "device-analytics_svg__icon device-analytics_svg__icon-tabler device-analytics_svg__icon-tabler-device-analytics",
  width: 24,
  height: 24,
  strokeWidth: 1.5,
  stroke: "currentColor",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z",
  stroke: "none"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 4,
  width: 18,
  height: 12,
  rx: 1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7 20h10M9 16v4M15 16v4M8 12l3-3 2 2 3-3"
})));
export default SvgDeviceAnalytics;